import {
    type IncomeSplitConfig,
    type IncomeSplitConfigLegacy,
    type IncomeSplitRule,
    type IncomeSplitRuleSet,
} from '@fruitful/income-split';
import { atom } from 'jotai';

import type { BankAccountDisplayDetail } from '../types/BankAccount';
import type { IncomeSplitRuleLegacy } from '../types/IncomeSplit';
import type {
    PaycheckRoutingConfig,
    PaycheckRoutingIncomeDetail,
    PaycheckRoutingRule,
} from '../types/PaycheckRouting';

export type TransformedPaycheckRoutingConfig = Omit<
    PaycheckRoutingConfig,
    'rules'
> & {
    rules: { primary: PaycheckRoutingRule[]; remaining: PaycheckRoutingRule[] };
};

export const existingPaycheckRoutingConfigsAtom = atom<
    TransformedPaycheckRoutingConfig[]
>([]);

export const currentlyEditingConfigAtom = atom<
    Partial<TransformedPaycheckRoutingConfig>
>({});

export const selectedIncomeAtom = atom<PaycheckRoutingIncomeDetail | null>(
    null,
);
export const selectedIncomeBankAccountAtom =
    atom<BankAccountDisplayDetail | null>(null);

export const selectedRuleAtom = atom<Partial<PaycheckRoutingRule> | null>(null);

export const detectedPaychecksAtom = atom<PaycheckRoutingIncomeDetail[]>([]);

export const incomeSplitAtomLegacy = atom<IncomeSplitConfigLegacy | null>(null);

export const incomeSplitAtom = atom<IncomeSplitConfig | null>(null);

export const selectedIncomeRuleAtomLegacy =
    atom<Partial<IncomeSplitRuleLegacy> | null>(null);

export const selectedIncomeRuleAtom = atom<Partial<IncomeSplitRule> | null>(
    null,
);

export const selectedRuleSetAtom = atom<IncomeSplitRuleSet | null>(null);

export const incomeSplitRuleEditorModeAtom = atom<'Edit' | 'Add' | null>(null);

export const incomeSplitRuleSetEditorModeAtom = atom<'Edit' | 'Add' | null>(
    null,
);

export const existingIncomeSplitConfigsAtomLegacy = atom<
    IncomeSplitConfigLegacy[]
>([]);

export const existingIncomeSplitConfigsAtom = atom<IncomeSplitConfig[]>([]);

export const selectedGroupAtom = atom<IncomeSplitRuleSet[]>([]);
